module.exports = __webpack_public_path__ + "static/media/services-bg-2.ad4efd7e.svg";